import React from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function PaymentCancelled() {
  const [searchParams] = useSearchParams();
  const quoteCode = searchParams.get("quote");

  return (
    <main className="section">
      <div className="container">
        <div className="contact-box">
          <div className="contact-text">
            <span className="section-label">Payment Cancelled</span>

            <h2>Your payment was not completed.</h2>

            <p>
              You can return to the payment link in your email and try again.
            </p>

            {quoteCode && (
              <p>
                <strong>Quote reference:</strong> {quoteCode}
              </p>
            )}

            <Link to="/" className="btn btn-primary">
              Back to Website
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}